<template>
    <tr>
        <td>BANDERA</td>
        <td class="text-right">
            <select class="form-control" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
                <option value=""></option>
                <option value="PETROMIL">PETROMIL</option>
                <option value="PRIMAX">PRIMAX</option>
                <option value="TERPEL">TERPEL</option>
                <option value="BIOMAX">BIOMAX</option>
                <option value="ZEUS">ZEUS</option>
                <option value="TEXACO">TEXACO</option>
            </select>
        </td>
    </tr>
</template>

<script>
export default {
    name: "BanderaSelector",
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    emits: ["update:modelValue"]
};
</script>